import React, { Fragment, JSX } from "react";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";

interface TagsTabProps {
  handleSaveTags: (tags) => void;
  handleRemoveTag: (allTags, tags) => void;
  selectedTagIds: Array<number>;
}
function TagsTab(props: TagsTabProps): JSX.Element {
  return (
    <Fragment>
      <div className="text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg">
        <div>
          <div className="relative flex">
            <div className="w-full">
              <div className="col-span-6">
                <TagSelector
                  label={"Tags"}
                  onTagSelectChange={(tags) => {
                    props.handleSaveTags(tags);
                  }}
                  removeTag={props.handleRemoveTag}
                  mode={TagSelectorMode.Edit}
                  categoryId={0}
                  selectedTagIds={props.selectedTagIds}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default TagsTab;
